export default {"src":"/_next/static/media/griddynamics-logo-min.4a97a1bc.svg","height":1486,"width":1501,"blurWidth":0,"blurHeight":0};